import { BuildPresentationProps } from '@features/lci-report/subdomains/visitation/utils/build-presentation';
import { Slide } from '@features/powerpoint';
import { appendixTitleSlide } from '../../../../slides/appendix/appendix-title-slide';
import { calculationsSlides } from '../../../../slides/appendix/calculations/slides';
import { visitAttributionTableSlides } from './dimension-tables/slides/visit-attribution-table';
import { emailSlide } from '../../../../slides/appendix/email/slide';
import { glossarySlides } from '../../../../slides/appendix/glossary/slides';
import { howWeDoItSlide } from '@features/lci-report/subdomains/visitation/slides/appendix/how-we-do-it-slide';
import { lciAdaptiveSyntheticControlSlide } from '@features/lci-report/subdomains/visitation/slides/appendix/lci-adaptive-synthetic-control-slide';
import { lciGuidelineMinimumsSlides } from '../../../../slides/appendix/lci-guideline-minimums/slide';
import { multiTouchAttributionSlide } from '../../../../slides/appendix/multi-touch-attribution/slide';
import { projectedVisitsMethodologySlide } from '../../../../slides/appendix/projected-visits-methodology/slide';
import { talkToUsSlide } from '../../../../slides/appendix/talk-to-us/slide';
import { salesAttributionTableSlides } from './dimension-tables/slides/sales-attribution-table';
import { GLOSSARY } from '@features/glossary/subdomains/visitation';

export const appendixSlidesFromProps = (
  props: BuildPresentationProps
): Slide[] =>
  props.customFields.includedSlides.appendix
    ? [
        appendixTitleSlide(),
        ...visitAttributionTableSlides(
          props.visitMetrics,
          props.dimensionTableData,
          props.customFields,
          props.calculatedFields
        ),
        ...(props.salesSummary
          ? salesAttributionTableSlides(
              props.visitMetrics,
              props.salesSummary,
              props.dimensionTableData,
              props.customFields
            )
          : []),
        ...glossarySlides({
          entriesPerColumn: [8, 8, 8, 8],
          glossary: GLOSSARY,
        }),
        ...calculationsSlides(),
        howWeDoItSlide(),
        lciAdaptiveSyntheticControlSlide(),
        multiTouchAttributionSlide({
          title: 'LCI 3.0 Multi Touch Attribution (MTA)',
          metricType: 'visits',
        }),
        projectedVisitsMethodologySlide(),
        ...lciGuidelineMinimumsSlides(),
        talkToUsSlide(),
        emailSlide(),
      ]
    : [];
